export const RoomType = {
    NORMAL: 1, // 普通房间
    FIRE_CONTROL: 2, // 消控室
    PUMPS: 3, // 泵房
}